module.exports = __webpack_public_path__ + "img/404.8c836e62.png";